// Injected by the shell-app vite config's `define` (appVersionBase + git commit count); absent
// under Vitest, which runs on the root config.
declare const __APP_VERSION__: string;

export class AppVersion {
    static readonly current: string = typeof __APP_VERSION__ === 'undefined' ? '0.0.0' : __APP_VERSION__;
    static readonly display: string = `v${AppVersion.current}`;
}
